import { elementDetailsBarStyles } from "./elementDetailsBar.css";
import { ElementDetailsBarProps } from "./types";

const ElementDetailsBar = ({
  children,
  variant = "default",
}: ElementDetailsBarProps) => (
  <div className={elementDetailsBarStyles[variant]} data-fixture-bar="true">
    {children}
  </div>
);

export default ElementDetailsBar;
